import React from "react";
import { BLOGS } from "../mock";
import { Calendar, ArrowRight, Tag } from "lucide-react";

export default function Blog() {
  return (
    <section id="blog" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <div className="text-xs font-bold uppercase tracking-[0.25em] text-yellow-700">Insights</div>
            <h2 className="display section-underline mt-3 text-4xl md:text-5xl font-extrabold text-slate-900 uppercase">
              Latest From The Site
            </h2>
          </div>
          <a href="#" className="inline-flex items-center gap-2 text-sm font-bold text-yellow-800 hover:text-yellow-900">
            View All Articles <ArrowRight className="w-4 h-4" />
          </a>
        </div>

        <div className="grid md:grid-cols-3 gap-7">
          {BLOGS.map((b) => (
            <article key={b.id} className="group bg-white border border-slate-200 rounded-xl overflow-hidden hover:shadow-xl hover:border-yellow-500 transition-all">
              <div className="aspect-[16/10] overflow-hidden">
                <img src={b.image} alt={b.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
              </div>
              <div className="p-7">
                <div className="flex items-center gap-4 text-xs text-slate-500">
                  <span className="flex items-center gap-1.5"><Calendar className="w-3.5 h-3.5" /> {b.date}</span>
                  <span className="flex items-center gap-1.5"><Tag className="w-3.5 h-3.5 text-yellow-700" /> {b.category}</span>
                </div>
                <h3 className="display mt-3 text-xl font-bold text-slate-900 group-hover:text-yellow-700 transition-colors leading-tight">
                  {b.title}
                </h3>
                <p className="mt-3 text-slate-600 text-sm leading-relaxed">{b.excerpt}</p>
                <a href="#" className="mt-5 inline-flex items-center gap-1 text-sm font-bold text-yellow-800 hover:text-yellow-900">
                  Read More <ArrowRight className="w-4 h-4" />
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
